import { Box, Link } from "@mui/material";
import { AcxMessageBox } from "components/UI/AcxMessageBox";
import { DRIVERS_HELP_CENTER_URL } from "components/UI/AcxEmptyStateIndicator/AcxEmptyState";
import type { ApplicationFilters } from "stores/ApplicationFilters/ApplicationFiltersStore";
import type { AuthStore } from "stores/AuthStore";
import {
    type AvailabilityFilterBannerKind,
    resolveAvailabilityFilterBanner,
} from "../DataAvailability/DataAvailability";

const HelpCenterArticleLink = () => (
    <Link
        href={DRIVERS_HELP_CENTER_URL}
        target="_blank"
        rel="noopener noreferrer"
        color="inherit"
        fontWeight={600}
    >
        Help Center article
    </Link>
);

const BannerContent = ({ kind }: { kind: AvailabilityFilterBannerKind }) => {
    switch (kind) {
        case "drivers":
            return (
                <>
                    Drivers replaced Topics on 7/1/26. To view data, apply a
                    date range after 7/1/26. Or, you can view historical Topics
                    data by using the legacy Topics filters. View our{" "}
                    <HelpCenterArticleLink /> for full instructions.
                </>
            );
        case "topics":
            return (
                <>
                    Drivers replaced Topics on 7/1/26. To view data, use the new
                    Drivers and Primary Themes filters instead. Or, you can view
                    historical Topics data by adding Topics reports to a custom
                    dashboard, and applying a date range prior to 7/1/26. View
                    our <HelpCenterArticleLink /> for full instructions.
                </>
            );
        case "driversSpanning":
            return (
                <>
                    Drivers replaced Topics on 7/1/26. This dashboard is
                    displaying Drivers-filtered data only for the portion of the
                    selected date range on or after that date. To view historical
                    data, use the legacy Topics filters. View our{" "}
                    <HelpCenterArticleLink /> for full instructions.
                </>
            );
        case "topicsSpanning":
            return (
                <>
                    Drivers replaced Topics on 7/1/26. This dashboard is
                    displaying Topics-filtered data only for the portion of the
                    selected date range prior to that date. To view data on or
                    after 7/1/26, use the new Drivers and Primary Themes filters
                    instead. View our <HelpCenterArticleLink /> for full
                    instructions.
                </>
            );
        case "mixedSpanning":
            return (
                <>
                    Drivers replaced Topics on 7/1/26. This date range includes
                    both historical Topics data and newer Drivers data. Legacy
                    Topics filters apply prior to 7/1/26, while Drivers and new
                    Primary Themes filters apply on or after that date. View our{" "}
                    <HelpCenterArticleLink /> for full instructions.
                </>
            );
    }
};

const DataAvailabilityFilterBanner = ({
    authStore,
    filters,
}: {
    authStore: AuthStore;
    filters: ApplicationFilters | null | undefined;
}) => {
    const bannerKind = resolveAvailabilityFilterBanner(filters, authStore);
    if (!bannerKind) return null;

    return (
        <Box sx={{ mx: 2, mb: 1 }}>
            <AcxMessageBox
                variant="info"
                sx={{ justifyContent: "flex-start" }}
            >
                <BannerContent kind={bannerKind} />
            </AcxMessageBox>
        </Box>
    );
};

export default DataAvailabilityFilterBanner;
